/*
 * Enum Only valid for the Distribution APIv2. For the Apiv1 check `ReleaseStoreEnum`
 */
var ReleaseDspNames;
(function (ReleaseDspNames) {
    // Main Dsps
    ReleaseDspNames["Spotify"] = "Spotify";
    ReleaseDspNames["Deezer"] = "Deezer";
    ReleaseDspNames["AppleMusic"] = "AppleMusic";
    ReleaseDspNames["YouTubeMusic"] = "YouTubeMusic";
    ReleaseDspNames["Tidal"] = "Tidal";
    ReleaseDspNames["IHeartRadio"] = "IHeartRadio";
    ReleaseDspNames["Pandora"] = "Pandora";
    ReleaseDspNames["Amazon"] = "Amazon";
    // Social
    ReleaseDspNames["TikTok"] = "TikTok";
    ReleaseDspNames["FacebookInstagram"] = "FacebookInstagram";
    // Recognition
    ReleaseDspNames["Gracenote"] = "Gracenote";
    // Specialized
    ReleaseDspNames["Beatport"] = "Beatport";
    // Others
    ReleaseDspNames["KkBox"] = "KkBox";
    ReleaseDspNames["Saavn"] = "Saavn";
    ReleaseDspNames["AWA"] = "AWA";
    ReleaseDspNames["SevenDigital"] = "SevenDigital";
    ReleaseDspNames["Anghami"] = "Anghami";
    ReleaseDspNames["TwentyFourSeven"] = "TwentyFourSeven";
    ReleaseDspNames["FLOMusic"] = "FLOMusic";
    ReleaseDspNames["Line"] = "Line";
    ReleaseDspNames["IMusica"] = "IMusica";
    ReleaseDspNames["Rhapsody"] = "Rhapsody";
    ReleaseDspNames["MediaNet"] = "MediaNet";
    ReleaseDspNames["Mdundo"] = "Mdundo";
    ReleaseDspNames["Tencent"] = "Tencent";
    ReleaseDspNames["NetEase"] = "NetEase";
    ReleaseDspNames["Taobao"] = "Taobao";
    ReleaseDspNames["SoundCloud"] = "SoundCloud";
    ReleaseDspNames["TikTokMusic"] = "TikTokMusic";
    ReleaseDspNames["Boomplay"] = "Boomplay";
    ReleaseDspNames["Qobuz"] = "Qobuz";
    ReleaseDspNames["ZingMP3"] = "ZingMP3";
})(ReleaseDspNames || (ReleaseDspNames = {}));
var ReleaseDspNameToLabel;
(function (ReleaseDspNameToLabel) {
    // Main Dsps
    ReleaseDspNameToLabel["Spotify"] = "Spotify";
    ReleaseDspNameToLabel["Deezer"] = "Deezer";
    ReleaseDspNameToLabel["AppleMusic"] = "Apple Music";
    ReleaseDspNameToLabel["YouTubeMusic"] = "YouTube Music";
    ReleaseDspNameToLabel["Tidal"] = "Tidal";
    ReleaseDspNameToLabel["IHeartRadio"] = "iHeartRadio";
    ReleaseDspNameToLabel["Pandora"] = "Pandora";
    ReleaseDspNameToLabel["Amazon"] = "Amazon";
    // Social
    ReleaseDspNameToLabel["TikTok"] = "TikTok";
    ReleaseDspNameToLabel["FacebookInstagram"] = "Facebook & Instagram";
    ReleaseDspNameToLabel["YouTubeContentID"] = "YouTube Content ID";
    // Recognition
    ReleaseDspNameToLabel["Gracenote"] = "Gracenote";
    // Specialized
    ReleaseDspNameToLabel["Beatport"] = "Beatport";
    // Others
    ReleaseDspNameToLabel["KkBox"] = "KkBox";
    ReleaseDspNameToLabel["Saavn"] = "JioSaavn";
    ReleaseDspNameToLabel["AWA"] = "AWA";
    ReleaseDspNameToLabel["SevenDigital"] = "7Digital";
    ReleaseDspNameToLabel["Anghami"] = "Anghami";
    ReleaseDspNameToLabel["TwentyFourSeven"] = "Nuuday A/S";
    ReleaseDspNameToLabel["FLOMusic"] = "FLO Music";
    ReleaseDspNameToLabel["Line"] = "LINE Music";
    ReleaseDspNameToLabel["IMusica"] = "iMusica";
    ReleaseDspNameToLabel["Rhapsody"] = "Napster";
    ReleaseDspNameToLabel["MediaNet"] = "MediaNet Digital";
    ReleaseDspNameToLabel["Mdundo"] = "Mdundo";
    ReleaseDspNameToLabel["Tencent"] = "Tencent Music Entertainment";
    ReleaseDspNameToLabel["NetEase"] = "NetEase Cloud Music";
    ReleaseDspNameToLabel["Taobao"] = "Taobao";
    ReleaseDspNameToLabel["SoundCloud"] = "SoundCloud";
    ReleaseDspNameToLabel["TikTokMusic"] = "TikTok Music (Resso)";
    ReleaseDspNameToLabel["Boomplay"] = "Boomplay";
    ReleaseDspNameToLabel["Qobuz"] = "Qobuz";
    ReleaseDspNameToLabel["ZingMP3"] = "Zing MP3";
})(ReleaseDspNameToLabel || (ReleaseDspNameToLabel = {}));
const ReleaseMainDspOrderedList = [
    ReleaseDspNames.Spotify,
    ReleaseDspNames.Deezer,
    ReleaseDspNames.AppleMusic,
    ReleaseDspNames.YouTubeMusic,
    ReleaseDspNames.Tidal,
    ReleaseDspNames.IHeartRadio,
    ReleaseDspNames.Pandora,
    ReleaseDspNames.Amazon,
];
const ReleaseSocialDspOrderedList = [
    ReleaseDspNames.FacebookInstagram,
    ReleaseDspNames.TikTok,
];
const ReleaseRecognitionDspOrderedList = [ReleaseDspNames.Gracenote];
const ReleaseOtherDspOrderedList = [
    ReleaseDspNames.Anghami,
    ReleaseDspNames.AWA,
    ReleaseDspNames.Boomplay,
    ReleaseDspNames.IMusica,
    ReleaseDspNames.KkBox,
    ReleaseDspNames.Line,
    ReleaseDspNames.MediaNet,
    ReleaseDspNames.Mdundo,
    ReleaseDspNames.NetEase,
    ReleaseDspNames.Qobuz,
    ReleaseDspNames.TikTokMusic,
    ReleaseDspNames.Rhapsody,
    ReleaseDspNames.Saavn,
    ReleaseDspNames.SevenDigital,
    ReleaseDspNames.Tencent,
    ReleaseDspNames.TwentyFourSeven,
    ReleaseDspNames.FLOMusic,
    ReleaseDspNames.Taobao,
    ReleaseDspNames.ZingMP3,
];

export { ReleaseDspNameToLabel, ReleaseDspNames, ReleaseMainDspOrderedList, ReleaseOtherDspOrderedList, ReleaseRecognitionDspOrderedList, ReleaseSocialDspOrderedList };
